import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'toggleHamburgerMenuContent',
    'toggleUserMenuContent',
    'toggleHamburgerMenuButton',
  ];
  static classes = ['hideButton'];

  connect() {
    this.htmlRoot = document.querySelector('html');

    if (this.isEmbeddedInWebflow()) {
      const document = window.top.document;
      const style = document.createElement('style');
      // top: -1px because the iframe did not close perfectly with the surrounding window,
      // creating a flickering effect on mobile Safari
      style.textContent = `
        .kr-prevent-scroll { overflow: hidden; }
        .kr-sticky-navbar {
          background: transparent;
          border: none;
          display: block;
          position: sticky;
          top: -1px;
          width: 100%;
          z-index: 99999999999;
        }
      `;
      document.head.appendChild(style);

      window.frameElement.id = 'kr-embedded-navbar';
      window.frameElement.classList.add('kr-sticky-navbar');
      window.frameElement.style.height = `${this.element.offsetHeight}px`;
    }
  }

  toggle(targets) {
    targets.forEach((target) => (target.hidden = !target.hidden));
  }

  togglePreventScrolling() {
    const hamburgerMenuVisible =
      this.getVisible(this.toggleHamburgerMenuContentTargets).length > 0;
    const userMenuVisible =
      this.getVisible(this.toggleUserMenuContentTargets).length > 0;

    if (this.isEmbeddedInWebflow()) {
      const preventScrolling = hamburgerMenuVisible || userMenuVisible;

      window.top.document
        .querySelector('html')
        .classList.toggle('kr-prevent-scroll', preventScrolling);
    } else {
      const preventScrolling =
        hamburgerMenuVisible || (userMenuVisible && window.innerWidth <= 768);

      this.htmlRoot.classList.toggle('prevent-scroll', preventScrolling);
    }
  }

  toggleHamburgerMenu() {
    this.toggle(this.getVisible(this.toggleUserMenuContentTargets));
    this.toggle(this.toggleHamburgerMenuContentTargets);
    this.toggleHamburgerMenuButtonTarget.classList.toggle(this.hideButtonClass);
    this.togglePreventScrolling();
    if (this.isEmbeddedInWebflow()) {
      this.toggleIframeFullscreen();
    }
  }

  toggleUserMenu() {
    this.toggle(this.getVisible(this.toggleHamburgerMenuContentTargets));
    this.toggle(this.toggleUserMenuContentTargets);
    this.toggleHamburgerMenuButtonTarget.classList.remove(this.hideButtonClass);
    this.togglePreventScrolling();
    if (this.isEmbeddedInWebflow()) {
      this.toggleIframeFullscreen();
    }
  }

  getVisible(elements) {
    return elements.filter((target) => target.getAttribute('hidden') == null);
  }

  toggleIframeFullscreen() {
    if (window.frameElement.classList.contains('is-fullscreen')) {
      window.frameElement.style.height = `${this.element.offsetHeight}px`;
      window.frameElement.style.position = null;
      window.frameElement.classList.remove('is-fullscreen');
    } else {
      window.frameElement.style.height = '100%';
      window.frameElement.style.position = 'fixed';
      window.frameElement.classList.add('is-fullscreen');
    }
  }

  // This Component is used in 2 places.
  // a) This Rails App
  // b) As an iframe embed on our Webflow static pages
  //
  // For b) the code needs to do a bit of tweaking with its environment, so that
  // it is rendered approriately and integrates well into the webflow page.
  isEmbeddedInWebflow() {
    return window.top.__isWebflow == true;
  }
}
